import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResultData } from '../_models/ResultData';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGroupService {


  constructor(private http: HttpClient, private headerService:HeaderService) {}

  createRoleGroup( formData:string ): Observable<ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/user/role/createNewRoleGroup`, formData, {headers: this.headerService.bearerFormHeaders()});
  }

  getRoleGroupName(role_group_id: number): Observable<ResultData> {
    return this.http.get<ResultData>(`${environment.apiUrl}/user/getRoleGroupName/${role_group_id}`,{headers: this.headerService.bearerFormHeaders()})
  }

   getPermissions(server_role_group_id:number):Observable<ResultData> {
      return this.http.get<ResultData>(`${environment.apiUrl}/user/role/index/${server_role_group_id}`,{headers: this.headerService.bearerJsonHeaders()})
    }

    getAllPermissions():Observable<ResultData> {
      return this.http.get<ResultData>(`${environment.apiUrl}/user/role/index`,{headers: this.headerService.bearerJsonHeaders()})
    }

     getRoleGroupById(id:number):Observable<ResultData> {
        return this.http.get<ResultData>(`${environment.apiUrl}/user/roleGroup/${id}`,{headers: this.headerService.bearerJsonHeaders()})

      }

      getRoleGroups():Observable<ResultData> {
        return this.http.get<ResultData>(`${environment.apiUrl}/user/roleGroupIndex`,{headers:this.headerService.bearerJsonHeaders()})
      }

      searchAbilityToAddToAbility(formData:string, id:number):Observable<ResultData> {
            return this.http.post<ResultData>(`${environment.apiUrl}/user/searchPermissionsToAddToRoleGroup/${id}`, formData, {headers:this.headerService.bearerFormHeaders()})

    }

    addPermissionToRoleGroup( formData:string):Observable<ResultData> {
      return this.http.post<ResultData>(`${environment.apiUrl}/user/permission/addToGroup`, formData, {headers:this.headerService.bearerFormHeaders()})
    }

    removePermissionFromRoleGroup( formData:string):Observable<ResultData> {
      return this.http.post<ResultData>(`${environment.apiUrl}/user/permission/removeFromGroup/`, formData, {headers:this.headerService.bearerFormHeaders()})
    }


    addUserToRoleGroup( formData:string):Observable<ResultData> {
      return this.http.post<ResultData>(`${environment.apiUrl}/user/role/addUser`, formData, {headers:this.headerService.bearerFormHeaders()})
    }

    removeUserFromRoleGroup( formData:string):Observable<ResultData> {
      return this.http.post<ResultData>(`${environment.apiUrl}/user/role/removeUser`, formData, {headers:this.headerService.bearerFormHeaders()})
    }

    getGroupPermissionCount( id:number):Observable<ResultData> {
      return this.http.get<ResultData>(`${environment.apiUrl}/user/permission/groupCount/${id}`, {headers:this.headerService.bearerJsonHeaders()})
    }


}
